import React from 'react'
import { Route, Redirect } from 'react-router-dom'

export const ProtectToLogIn = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={
            (props) => {
                if (localStorage.getItem('token')) {
                    return <Component {...props} />
                } else {
                    return <Redirect to={{pathname: "/", state: {from: props.location}}} />
                }
            }
        } />
    )
}

export const ProtectExternal = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={
            (props) => {
                if(localStorage.getItem('AspiranteToken')){
                    return <Redirect to={{pathname: "/aspiranteInicio", state: {from: props.location}}} />
                }

                if (localStorage.getItem('token')) {
                    return <Redirect to={{pathname: "/inicio", state: {from: props.location}}} />
                } else {
                    return <Component {...props} />
                }

            }
        } />
    )
}

export const ProtectAspirante = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={
            (props) => {
                if (localStorage.getItem('AspiranteToken')) {
                    return <Component {...props} />
                } else {
                    return <Redirect to={{pathname: "/aspiranteInicio", state: {from: props.location}}} />
                }
            }
        } />
    )
}

